import React, { useState } from 'react';
import { toast } from 'sonner';
import { UserPlus, Users } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../../ui/dialog';
import { Switch } from '../../ui/switch';
import { haccpApi, erroreHaccp } from '../haccpApi';

export const PersoneDialog = ({ open, persone, onClose, onCambiato }) => {
  const [nome, setNome] = useState('');
  const aggiungi = async () => {
    try { await haccpApi.post('/documenti/persone', { nome }); setNome(''); toast.success('Persona aggiunta'); onCambiato(); }
    catch (e) { toast.error(erroreHaccp(e, 'Persona non aggiunta')); }
  };
  const servizio = async (p, attivo) => {
    try { await haccpApi.post(`/documenti/persone/${encodeURIComponent(p.id)}/servizio`, { attivo }); onCambiato(); }
    catch (e) { toast.error(erroreHaccp(e, 'Non aggiornato')); }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md rounded-2xl" data-testid="documenti-persone-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><Users className="h-5 w-5" />Persone</DialogTitle>
          <DialogDescription>Chi ha un accesso all'app compare da solo. Aggiungi chi non ce l'ha. Chi non lavora più qui esce dai controlli.</DialogDescription>
        </DialogHeader>
        <div className="flex gap-2">
          <input value={nome} onChange={(e) => setNome(e.target.value)} placeholder="Nome e cognome" data-testid="documenti-persona-nome"
            className="flex-1 h-11 px-3 rounded-lg border border-gray-300 text-sm text-gray-900 bg-white" />
          <button onClick={aggiungi} disabled={nome.trim().length < 2} data-testid="documenti-persona-aggiungi"
            className="h-11 px-4 rounded-lg bg-gray-900 text-white text-sm flex items-center gap-1 disabled:opacity-50"><UserPlus className="h-4 w-4" />Aggiungi</button>
        </div>
        <div className="max-h-[50vh] overflow-y-auto space-y-1.5">
          {persone.map((p) => (
            <div key={p.id} className="flex items-center justify-between gap-2 border border-gray-200 bg-white rounded-lg p-2.5" data-testid={`documenti-persona-${p.id}`}>
              <div className="min-w-0">
                <p className={`text-sm font-medium ${p.attivo ? 'text-gray-900' : 'text-gray-400 line-through'}`}>{p.nome}</p>
                <p className="text-[11px] text-gray-500">{p.origine === 'team' ? `Team${p.ruolo ? ` · ${p.ruolo}` : ''}` : p.origine === 'haccpok' ? 'Da HaccpOK' : 'Aggiunta a mano'}</p>
              </div>
              <label className="flex items-center gap-2 text-xs text-gray-600">In servizio
                <Switch checked={p.attivo} onCheckedChange={(v) => servizio(p, v)} data-testid={`documenti-persona-servizio-${p.id}`} />
              </label>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
};
